<div class="row mt-3">
    <div class="col-2 col-2-container">
        <span>{{ name }}:</span>
    </div>
    <div
        class="col-2"
        [ngClass]="getColumnWidth()"
        [class.required]="isMandatory() && isEmpty"
        [class.notRequired]="!isMandatory() || !isEmpty">
        @if (dataType === 'NumericTextBox') {
            <kendo-numerictextbox
                class="inputElement"
                [disabled]="disabled"
                [decimals]="dataFormat === 'decimal' ? 3 : 0"
                [format]="dataFormat === 'decimal' ? 'n3' : 'n0'"
                [(value)]="value"
                (input)="isEmpty = $event.target.value === ''"></kendo-numerictextbox>
        }

        @if (dataType === 'Checkbox') {
            <input
                class="inputElementCheckbox"
                type="checkbox"
                kendoCheckBox
                [disabled]="disabled"
                [checked]="value"
                (change)="booleanValueChange($event)"
                (input)="isEmpty = !$event.target.checked" />
        }

        @if (dataType === 'DateTime') {
            <kendo-datetimepicker
                class="inputElement"
                [disabled]="disabled"
                [format]="'dd.MM.yyyy HH:mm'"
                [(value)]="value"
                (input)="isEmpty = $event.target.value === ''"></kendo-datetimepicker>
        }

        @if (dataType === 'TextBox' && dataFormat === 'email') {
            <input
                class="inputElementEmail"
                type="email"
                kendoTextBox
                [disabled]="disabled"
                [value]="value"
                (change)="textValueChange($event)"
                (input)="isEmpty = $event.target.value === ''" />
        }

        @if (dataType === 'TextBox' && dataFormat !== 'email') {
            <div class="textDiv" (click)="clickedOnTextDiv()">
                <div
                    [ngClass]="{
                        notGrayedOutSpan: !disabled,
                        grayedOutSpanDefault: disabled && !isTextExpanded,
                        grayedOutSpanExpanded: disabled && isTextExpanded
                    }"
                    [contentEditable]="!disabled"
                    (input)="handleTextChange($event)">
                    <span>{{ defaultValue }}</span>
                </div>
            </div>
        }
    </div>
    <div class="col-8"></div>
</div>
